<template>
    <div class="device_detail_main_card">
        <div class="device_detail_main_card_title">
            <div>{{ $t('subscription') }}</div>
        </div>
        <div class="device_detail_main_card_less" v-if="currentSubscription">
            <ReoDescription
                :title="$t('dashboard.current_plan')"
                :content="getServiceName()"
            />
            <ReoDescription
                :title="$t('dashboard.device_detail.valid_until')"
                :content="subscriptionActive?formatTime(planEndTime,$t, '12'):$t('dashboard.device_detail.main_card.expired')"
            />
            <ReoEdit
                v-if="isLocked && currentSubscription.planInfo?.series?.category === ESeriesCategory.CLOUD_STORAGE_DATA_PLAN"
                :uid="simManager?.data.esimDevice"
            />
            <div class="device_detail_main_card_more_menu"
                @click.stop
                v-if="moreMenuBtnShow && currentSubscription">
                <reo-common-button
                    @click="handleShowMenu"
                    :label="$t('my_sim.manage_subscription')"
                    color-type="light"
                    class="more_button"
                    size="middle"
                    :custom-width="isMobile? '100%':undefined"
                />
                <div v-if="isMobile && showItems.moreMenuShow" class="more-menu-mask" @click="handleShowMenu"></div>
                <div class="device_detail_main_card_more_menu_items" v-show="showItems.moreMenuShow">
                    <li @click="handleMoreMenuAction('renew')" v-if="getMoreMenuItemVisibility('renew')">
                        {{ $t('dashboard.device_detail.more_menu.renew') }}
                    </li>
                    <li @click="handleMoreMenuAction('addOn')" v-if="getMoreMenuItemVisibility('addOn')">
                        {{ $t('dashboard.device_detail.more_menu.add_on') }}
                    </li>
                    <li @click="handleMoreMenuAction('switch')" v-if="getMoreMenuItemVisibility('switch')">
                        <div>{{ $t('dashboard.device_detail.more_menu.switch') }}</div>
                        <div class="danger_tip">{{ $t('dashboard.device_detail.more_menu.switch_tip') }}</div>
                    </li>
                    <div v-if="isMobile && showItems.cancelMenuShow"
                        class="more-menu-mask"
                        @click="showItems.cancelMenuShow = false"></div>
                    <li
                        @click="toggleCancelMenu"
                        :class="{'active': showItems.cancelMenuShow}"
                        v-if="getMoreMenuItemVisibility('cancel')"
                    >
                        {{ $t('dashboard.device_detail.more_menu.cancel') }}
                        <div class="device_detail_main_card_more_menu_items cancel_menu"
                            v-if="showItems.cancelMenuShow">

                            <li @click="handleMoreMenuAction('cancel', currentSubscription.id)"
                                v-if="isSubscriptionActionVisible(currentSubscription, 'cancel')">
                                {{ $t('dashboard.device_detail.main_card.cancel_all') }}{{
                                    isCloudStorageDataPlan ? $t("dashboard.device_detail.main_card.add_on_included") : ""
                                }}
                            </li>
                            <li
                                v-for="(item, index) in cancellableAddOns"
                                :key="item.id"
                                @click="handleMoreMenuAction('cancel',item.id)"
                            >
                                {{ index + 1 }}.
                                {{ getServiceName(item.id) }}
                            </li>
                        </div>
                    </li>
                </div>
            </div>
            <AutoRenewSwitch
                v-show="showItems.mainCardShowMore && showAutoRenew "
                :autoRenewal="autoRenew"
                @update:autoRenew="$emit('refresh');autoRenew = $event;"
                :subscription-id="currentSubscription?.id"
                :next-billing-at="currentSubscription?.nextBillingAt"
                @renew="()=>handleMoreMenuAction('renew')"
            />

            <div class="device_detail_main_card_item device_detail_main_card_add_on"
                v-show="activeAddOns.length>0 && showItems.mainCardShowMore">
                <p class="device_detail_main_card_dark_text">
                    {{ $t('dashboard.device_detail.add_on') }}
                    <button class="device_detail_detail_btn"
                        @click="showItems.showDialogs.addOn=!showItems.showDialogs.addOn"
                    >{{ $t('dashboard.device_detail.details') }}
                    </button>
                    <ReoDialog
                        v-if="showItems.showDialogs.addOn"
                        @cancel="showItems.showDialogs.addOn=false"
                        @confirm="showItems.showDialogs.addOn=false"
                        :label-of-confirm="$t('dashboard.device_detail.i_know_it')"
                        :is-horizontally='false'
                        :title="$t('my_sim.add_on_info')"
                    >
                        <div class="add_on_dialog_content add_on_info_card"
                            v-for="(item,index) in activeAddOns"
                            :key="item.id">
                            <p><span class="number">{{ index + 1 }}</span>{{ getServiceName(item.id) }}</p>
                            <p>
                                <span class="add_on_dialog_content_secondary">
                                    {{ $t('dashboard.device_detail.main_card.valid_until') + ': ' }}
                                </span>
                                {{ formatTime(item.endingAt,$t, '12') }}
                            </p>
                            <p>
                                <span class="add_on_dialog_content_secondary">
                                    {{ $t('dashboard.device_detail.content') }}
                                </span>
                                {{
                                    $t('dashboard.device_detail.main_card.add_on_content', {dataSize: calcFinalDataStr(item.dataSize, true)})
                                }}
                            </p>
                        </div>
                        <div class="add_on_dialog_content add_on_dialog_content_last">
                            <div>
                                <p>{{ $t('dashboard.device_detail.main_card.note') }}</p>
                                <p>{{ $t('dashboard.device_detail.main_card.add_on_note.note_1') }}</p>
                                <p class="title">{{ $t('dashboard.device_detail.main_card.add_on_note.note_2') }}</p>
                                <p>{{ $t('dashboard.device_detail.main_card.add_on_note.note_3') }}</p>
                                <p class="title">{{ $t('dashboard.device_detail.main_card.add_on_note.note_4') }}</p>
                                <p>{{ $t('dashboard.device_detail.main_card.add_on_note.note_5') }}</p>
                                <p class="title">{{ $t('dashboard.device_detail.main_card.add_on_note.note_6') }}</p>
                                <p>{{ $t('dashboard.device_detail.main_card.add_on_note.note_7') }}</p>
                            </div>
                        </div>
                    </ReoDialog>

                </p>
                <ol>
                    <li v-for="(item, index) in activeAddOns" :key="item.id">
                        <span class="order">{{ index + 1 }}</span>
                        <span>{{ getServiceName(item.id) }}</span>

                    </li>
                </ol>
            </div>

            <ShowMoreButton v-model="showItems.mainCardShowMore" v-if="canShowMore"/>
        </div>
        <div class="device_detail_main_card_content device_detail_main_card_no_plan" v-else>
            <p>{{ $t('dashboard.device_detail.no_plan') }}</p>
            <ReoCommonButton :label="$t('dashboard.device_detail.purchase')"
                size="middle"
                @click="handlePlanPurchase"
                v-if="!simManager.isRetired"
            />
        </div>
    </div>
</template>

<script lang="ts">
import ReoDialog from '@/basic/Dialog.vue';
import reolinkGa from '@/common/js/gtagPageview';
import {
    BoundStatus,
    ESeriesCategory,
    ESubscribeMode,
    ICloudService,
    IPlan,
    ISelectorStyle,
    ISubDevice
} from '@reolink-cloud/interface';
import ReoCommonButton from '@/components/ReoCommonButton.vue';
import Vue, { PropType } from 'vue';
import { config } from 'CONFIG';
import { uidHandler } from '@/lib/uidHandler';
import { calcFinalDataStr } from '@/common/js/utils';
import ReoDescription from './components/ReoDescription.vue';
import { SimManager } from '@/lib/simManager';
import { eventBus, getEmitterId, CloseMenuEvent as CloseMenuEvent } from './lib/eventBus';
import AutoRenewSwitch from '@/components/AutoRenewSwitch.vue';
import ShowMoreButton from '@/components/ShowMoreButton.vue';
import { formatTime } from '@/utils/time';
import ReoEdit from 'VIEW/user/MySim/components/components/ReoEdit.vue';

type MoreMenuItemType = 'renew' | 'addOn' | 'switch' | 'cancel';

export default Vue.extend({
    components: {
        ReoEdit,
        ReoDescription,
        ReoDialog,
        ReoCommonButton,
        ShowMoreButton,
        AutoRenewSwitch
    },
    props: {
        simManager: Object as PropType<SimManager>,
        subDevice: Object as PropType<ISubDevice>,
        boundStatus: String as PropType<BoundStatus>,
        from: String as PropType<'my-devices' | 'cloud-dashboard'>,
    },
    data() {

        return {
            showItems: {
                showDialogs: {
                    addOn: false,
                    autoRenew: false,
                    disableAutoRenew: false,
                    signPaypal: false
                },
                mainCardShowMore: false,
                moreMenuShow: false,
                cancelMenuShow: false,
                subMenuOpen: false,
            },
            paths: {
                renew: '/checkout/',
                addOn: '/user/subscribe-plan/sim/choose',
                switch: '/user/subscribe-plan/sim/choose',
                cancel: '/user/cancel-plan/',
                purchase: '/user/subscribe-plan/sim/choose',
                lock: '/user/subscribe-plan/lock/choose',
            },
            config,
            id: getEmitterId(),
            ESeriesCategory
        };

    },
    created() {

        const cancel = Boolean( this.$route.query['cancel'] === 'false' ? '' : this.$route.query['cancel'] );
        eventBus.addEventListener( 'close-menu', this.hideMoreMenu );
        if ( cancel ) {

            this.showItems.moreMenuShow = true;
            this.showItems.cancelMenuShow = true;

        }

    },
    mounted() {

        window.addEventListener( 'click', this.hideMoreMenu );

    },
    beforeDestroy() {

        window.removeEventListener( 'click', this.hideMoreMenu );
        eventBus.removeEventListener( 'close-menu', this.hideMoreMenu );

    },
    computed: {
        isLocked(): boolean {

            return !!this.simManager?.data.esimDevice;

        },

        moreMenuBtnShow(): boolean {

            return this.getMoreMenuItemVisibility( 'addOn' )
                || this.getMoreMenuItemVisibility( 'cancel' )
                || this.getMoreMenuItemVisibility( 'renew' )
                || this.getMoreMenuItemVisibility( 'switch' );

        },
        showAutoRenewInfo(): boolean | undefined {

            return this.autoRenew && !this.unBound && !( this.cloudStorageDataPlanWithNoSim );

        },
        gaSuffer(): string {

            switch ( this.from ) {

                case 'my-devices':
                    return 'Devices';
                case 'cloud-dashboard':
                    return 'Dashboard';
                default:
                    return '';

            }

        },
        cloudStorageDataPlanWithNoSim(): boolean {

            return false;

        },
        unBound(): boolean {

            return this.boundStatus === 'unbound';

        },

        subscriptionActive(): boolean {

            return this.currentSubscription?.effectiveStatus !== 'inactive';

        },
        autoRenew: {
            get(): boolean {

                return this.currentSubscription?.autoRenewal ?? false;

            },
            set( val: boolean ) {

                if ( this.currentSubscription ) {

                    this.currentSubscription.autoRenewal = val;

                }

            }
        },

        selectorStyle(): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: 1,
                heightOut: 0.32,
                widthIn: 1,
                heightIn: 0.32,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 3.08,
                fontSizeIn: 0.16,
                fontSizeOut: 0.16
            } : {
                widthOut: -1,
                heightOut: 0.32,
                widthIn: -1,
                heightIn: 0.4,
                selectMarginLeft: 0.12,
                triangleRight: 0.12,
                maxHeight: 4.75,
                fontSizeIn: 0.17,
                fontSizeOut: 0.13
            };

        },

        resourceSelectorStyle(): ISelectorStyle {

            return !this.isMobile ? {
                ...this.selectorStyle,
                widthOut: 1.16,
                widthIn: 1.16
            } : this.selectorStyle;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        isFreeSub(): boolean {

            if ( this.currentSubscription?.planInfo ) {

                if ( Number( this.currentSubscription.planInfo.pricing.salePrice ) === 0 ) {

                    return true;

                }

            }
            return false;

        },
        plan(): IPlan | undefined {

            return this.currentSubscription?.planInfo;

        },
        cancellableAddOns(): ICloudService[] {

            return this.simManager.serviceArr.filter( service => service.type === 'package' && this.isSubscriptionActionVisible( service, 'cancel' ));

        },
        isCloudStorageDataPlan(): boolean {

            return this.currentSubscription?.planInfo?.series?.category === ESeriesCategory.CLOUD_STORAGE_DATA_PLAN;

        },
        subscriptionSimIccId(): string | undefined {

            for ( const association of this.currentSubscription?.associations ?? [] ) {

                if ( 'iccid' in association && association.status === 'active' ) {

                    return association.iccid;

                }

            }

            return undefined;

        },
        showAutoRenew(): boolean {

            return this.isSubscriptionActionVisible( this.currentSubscription, 'autoRenew' );

        },
        currentSubscription(): ICloudService | undefined {

            return this.simManager.currentSubscription;

        },
        activeAddOns(): ICloudService[] {

            return this.simManager.activeAddOns;

        },
        subscriptionType(): ESeriesCategory | undefined {

            return this.currentSubscription?.planInfo?.series?.category;

        },
        /**
         * show more是否有内容
         */
        canShowMore(): boolean {

            return this.showAutoRenew || this.activeAddOns.length > 0;

        },
        planEndTime(): number {

            return this.currentSubscription?.endingAt ?? 0;

        },
    },
    methods: {
        formatTime,

        calcFinalDataStr,
        isSubscriptionActionVisible( service: ICloudService | undefined, action: 'renew' | 'autoRenew' | 'cancel' | 'switch' ): boolean {

            return service?.actionConfig?.[action]?.visibility === 'visible';

        },
        hideMoreMenu( arg: CloseMenuEvent | Event ) {

            if ( arg instanceof CloseMenuEvent && arg.detail.senderId === this.id ) {

                return;

            }

            this.showItems.moreMenuShow = false;
            this.showItems.cancelMenuShow = false;
            this.showItems.subMenuOpen = false;

        },
        toggleCancelMenu() {

            this.showItems.cancelMenuShow = !this.showItems.cancelMenuShow;
            this.showItems.subMenuOpen = this.showItems.cancelMenuShow;

        },
        getMoreMenuItemVisibility( type: MoreMenuItemType ): boolean {

            switch ( type ) {

                case 'renew':
                    return this.isSubscriptionActionVisible( this.currentSubscription, 'renew' );
                case 'addOn':
                    return !this.simManager.isRetired
                        && this.subscriptionActive
                        && !this.unBound
                        && [ESeriesCategory.CLOUD_STORAGE_DATA_PLAN, ESeriesCategory.CLOUD_DATA_PLAN].includes( this.subscriptionType! ) && this.activeAddOns.length < 10
                        && !this.cloudStorageDataPlanWithNoSim;
                case 'cancel': {

                    return this.isSubscriptionActionVisible( this.currentSubscription, 'cancel' ) || this.cancellableAddOns.length > 0;

                }
                case 'switch':
                    return this.isSubscriptionActionVisible( this.currentSubscription, 'switch' );
                default:
                    return true;

            }

        },
        async handleMoreMenuAction( type: MoreMenuItemType, cancelId?: string ) {

            switch ( type ) {

                case 'renew':
                    await this.$router.push({
                        path:  this.paths.renew,
                        query: {
                            ps_id: this.currentSubscription?.id,
                            p_id: this.currentSubscription?.planInfo?.id,
                            ymh: uidHandler.encrypt( this.simManager.iccid ),
                            mode: 'renew'
                        }
                    });
                    break;
                case 'addOn':
                    await this.$router.push({
                        path: this.paths.addOn,
                        query: {
                            isAddOn: 'true',
                            ymh: uidHandler.encrypt( this.simManager.iccid ),
                            s_id: this.currentSubscription?.id
                        }
                    });
                    break;
                case 'switch':
                    if ( this.isLocked ) {

                        await this.$router.push({
                            path: this.paths.lock,
                            query: {
                                ps_id: this.currentSubscription?.id,
                                ymh: uidHandler.encrypt( this.simManager.iccid ),
                                mode: ESubscribeMode.SWITCH
                            }
                        });

                    } else {

                        await this.$router.push({
                            path:  this.paths.switch,
                            query: {
                                ymh: uidHandler.encrypt( this.simManager.iccid ),
                                s_id: this.currentSubscription?.id,
                                mode: ESubscribeMode.SWITCH
                            }
                        });

                    }
                    break;
                case 'cancel':
                    await this.$router.push({
                        path: this.paths.cancel,
                        query: {
                            ps_id: String( cancelId ),
                            ymh: uidHandler.encrypt( this.simManager.iccid )
                        }
                    });
                    break;

            }

        },
        getServiceName( addOnPlanId?: string ) {

            if ( addOnPlanId ) {

                return this.simManager.data.services?.[addOnPlanId].planInfo?.series?.i18n.name;

            } else {

                return this.$t( 'dashboard.plan_subscribed', {
                    planName: ['', undefined, null].includes( this.simManager.currentSubscriptionPlanName ) ?
                        this.$t( 'dashboard.unknow_plan' ) : this.simManager.currentSubscriptionPlanName
                });

            }

        },

        async handlePlanPurchase() {

            if ( this.gaSuffer ) {

                reolinkGa.sendSimpleEvent( `${this.gaSuffer}-Sim-Purchase a Plan` );

            }
            if ( this.isLocked ) {

                await this.$router.push({
                    path: this.paths.lock,
                    query: {
                        ymh: uidHandler.encrypt( this.simManager.iccid ),
                        mode: ESubscribeMode.CREATE
                    }
                });

            } else {

                await this.$router.push({
                    path: this.paths.purchase,
                    query: {
                        ymh: uidHandler.encrypt( this.simManager.iccid ),
                    }
                });

            }

        },
        handleShowMenu() {

            this.showItems.moreMenuShow = !this.showItems.moreMenuShow;
            eventBus.dispatchEvent( new CloseMenuEvent( this.id ));

        },
    },
    watch: {
        currentSubscription() {

            this.autoRenew = this.currentSubscription?.autoRenewal ?? false;

        },
        from() {

            if ( this.from === 'my-devices' ) {

                this.gaSuffer = 'Devices';

            } else if ( this.from === 'cloud-dashboard' ) {

                this.gaSuffer = 'Dashboard';

            }

        }
    }
});

</script>

<style lang="less" scoped>
.device_detail_main_card {
    .reo-card();
    font-family: @font_02;
    line-height: normal;
    letter-spacing: 0em;

    .device_detail_main_card_title {
        display: flex;
        justify-content: space-between;
        padding: 16px 20px;
        font-size: 20px;
        font-weight: 600;
        border-bottom: 1px solid @line;

        @media @mobile {
            font-size: 22px;
            align-items: center
        }

        a {
            display: flex;
            cursor: pointer;

            img {
                width: 36px;

                @media @mobile {
                    width: 26px;
                }
            }
        }

    }

    .device_detail_main_card_more_menu {
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
        position: relative;
        padding-top: 24px;
        @mask_z_index: 100;

        img {
            width: 24px;
            vertical-align: bottom;

            @media @mobile {
                width: 18px;
            }
        }

        .more-menu-mask {
            position: fixed;
            width: 100vw;
            height: 100vh;
            background-color: @black6;
            top: 0;
            left: 0;
            z-index: @mask_z_index;
        }

        .device_detail_main_card_more_menu_items {
            position: absolute;
            top: 70%;
            right: 15px;
            z-index: 10;
            background-color: @bg_02;
            border: 1px solid @line;
            border-radius: 8px;
            box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.23);
            z-index: @mask_z_index + 1;

            @media @mobile {
                position: fixed;
                bottom: 0;
                left: 0;
                top: unset;
                right: unset;
                width: 100%;
                box-sizing: border-box;
            }

            li:first-of-type {
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                .mobile({
                    padding-top: 26px;
                })
            }

            li:last-of-type {
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                .mobile({
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                    padding-bottom: 28px;
                })
            }

            li {
                position: relative;
                font-family: @font_02;
                font-size: 14px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0em;
                color: @font_primary;
                width: 280px;
                display: flex;
                padding: 8px 6px;
                flex-direction: column;
                align-items: center;
                gap: 4px;
                line-break: anywhere;
                .mobile({
                    width: 100%;
                    box-sizing: border-box;
                    padding: 16px;
                    border-top: 1px solid @line;
                });

                .device_detail_main_card_more_menu_items {
                    left: 100%;
                    top: 0;
                    right: unset;

                    @media @mobile {
                        left: 0;
                        top: unset;
                        z-index: @mask_z_index + 2;
                    }
                }

                &:hover {
                    background-color: @brand_light;
                    color: @white;
                }

                &.active {
                    background-color: @brand_light;
                    color: @white;
                }

                .danger_tip {
                    text-align: center;
                    font-size: 12px;
                    font-weight: 500;
                    color: @error;
                }
            }
        }

    }

    .device_detail_main_card_dark_text {
        white-space: pre;
        font-size: 18px;
        font-weight: 600;
    }

    .device_detail_main_card_less {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 32px 20px;

        .device_detail_main_card_times {
            display: flex;
            flex-direction: column;
            gap: 6px;
            margin-top: 12px;
            margin-bottom: 16px;

            @media @mobile {
                margin-bottom: 12px;
            }

            & > p {
                display: flex;
                align-items: center;

                img {
                    width: 16px;
                    margin-right: 8px;
                }
            }
        }
    }

    .device_detail_main_card_dark_text {
        white-space: normal;
    }

    .device_detail_main_card_item {
        display: flex;
        flex-direction: column;
        gap: 4px;

    }

    .device_detail_main_card_add_on {
        .device_detail_main_card_dark_text {
            display: flex;
            justify-content: space-between;
            align-items: center
        }

        .add_on_dialog_content {
            display: flex;
            flex-direction: column;
            text-align: left;
            padding-bottom: 24px;

            .title {
                margin-top: 5px;
                font-weight: 700;
            }

            &_last {
                padding-top: 24px;
                border-bottom: none;

                p {
                    font-size: 15px;
                    font-weight: 500;
                }
            }

            .add_on_dialog_content_secondary {
                color: @font_secondary
            }

        }

        .add_on_info_card {
            background-color: @bg_01;
            border-radius: 12px;
            padding: 16px;
            gap: 12px;

            &:not(:first-of-type) {
                margin-top: 12px;
            }

            .number {
                font-size: 14px;
                font-weight: 500;
                color: @white;
                width: 18px;
                height: 18px;
                background-color: @b_4;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 100%;
                margin-right: 8px;
            }

            p {
                font-size: 16px;
                font-weight: 500;
            }
        }

        ol {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 8px;

            li {

                font-family: @font_02;
                font-size: 14px;
                font-weight: 500;
                line-height: normal;
                letter-spacing: 0em;
                color: @font_secondary;
                display: flex;
                gap: 8px;
                align-items: center;

                .order {
                    border-radius: 100%;
                    background-color: @b_4;
                    font-size: 14px;
                    font-weight: 500;
                    color: white;
                    width: 18px;
                    height: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

            }
        }
    }

    .device_detail_main_card_no_plan {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 32px 20px;
        align-items: flex-start;

        p {
            font-size: 18px;
            font-weight: 600;
        }

        .ui-link {
            .text {
                font-size: 14px;
            }
        }
    }

    .device_detail_detail_btn {
        border: none;
        background-color: transparent;
        font-family: @font_02;
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;
        color: @brand_light;
        cursor: pointer;
        padding: 0;

        &:hover {
            color: @brand_light_hover;
        }
    }

}
</style>
<style>
body:has(.more-menu-mask) {
    overflow: hidden;
}
</style>
